/* [Modified by Codex at 2026-09-14] 在用户操作商品轮播时按需加载后五件商品 */
(() => {
  if (window.VedressProductCarouselLazy) return;

  const responseCache = new Map();
  const selector = '.bls__swiper[data-vedress-lazy-carousel="true"]';

  class VedressProductCarouselLazy {
    constructor(carousel) {
      this.carousel = carousel;
      this.nextButton = carousel.querySelector(".swiper-button-next");
      this.handleIntent = this.handleIntent.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);

      if (carousel.dataset.vedressLazyBound === "true") return;
      carousel.dataset.vedressLazyBound = "true";

      carousel.addEventListener("pointerenter", this.handleIntent, { once: true });
      carousel.addEventListener("focusin", this.handleIntent, { once: true });
      carousel.addEventListener("touchstart", this.handleIntent, { once: true, passive: true });
      this.nextButton?.addEventListener("click", this.handleNextClick, true);
    }

    handleIntent() {
      this.load();
    }

    handleNextClick(event) {
      if (this.carousel.dataset.lazyLoaded === "true") return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.load().then((loaded) => {
        if (loaded) this.carousel.swiper?.slideNext();
      });
    }

    load() {
      if (this.carousel.dataset.lazyLoaded === "true") return Promise.resolve(true);
      if (this.loadingPromise) return this.loadingPromise;

      const url = this.carousel.dataset.lazyUrl;
      const status = this.carousel.querySelector(".vedress-product-carousel-status");
      if (!url) return Promise.resolve(false);

      this.carousel.setAttribute("aria-busy", "true");
      if (status) status.textContent = "正在加载后五件商品。";

      this.loadingPromise = this.fetchMarkup(url)
        .then((markup) => {
          const responseDocument = new DOMParser().parseFromString(markup, "text/html");
          const source = responseDocument.querySelector(".vedress-carousel-products");
          if (!source) throw new Error("Lazy carousel response is missing its content wrapper.");

          const incomingSlides = Array.from(source.querySelectorAll(":scope > .swiper-slide"));
          const placeholders = Array.from(
            this.carousel.querySelectorAll(".vedress-product-carousel-placeholder"),
          );
          if (!incomingSlides.length) throw new Error("No products were returned for the carousel.");

          placeholders.forEach((placeholder, index) => {
            const slide = incomingSlides[index];
            if (slide) {
              placeholder.replaceWith(slide);
            } else {
              placeholder.remove();
            }
          });

          this.carousel.dataset.lazyLoaded = "true";
          this.initializeProductCards(this.carousel);
          this.carousel.swiper?.update();
          this.carousel.swiper?.navigation?.update();
          if (status) status.textContent = "后五件商品已加载。";
          return true;
        })
        .catch((error) => {
          console.error("Unable to load remaining carousel products:", error);
          if (status) status.textContent = "后五件商品加载失败，请使用查看全部链接。";
          return false;
        })
        .finally(() => {
          this.carousel.removeAttribute("aria-busy");
          this.loadingPromise = null;
        });

      return this.loadingPromise;
    }

    fetchMarkup(url) {
      if (!responseCache.has(url)) {
        const request = fetch(url, {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Request failed with status ${response.status}.`);
            return response.text();
          })
          .catch((error) => {
            responseCache.delete(url);
            throw error;
          });
        responseCache.set(url, request);
      }

      return responseCache.get(url);
    }

    initializeProductCards(root) {
      this.initializeLazyImages(root);

      if (window.BlsColorSwatchesShopify) {
        root.querySelectorAll(".bls__product-color-swatches").forEach((swatch) => {
          window.BlsColorSwatchesShopify.checkSwatches(swatch);
        });

        root
          .querySelectorAll(".bls__option-swatch-js,.bls__product-compare,.bls__product-wishlist")
          .forEach((control) => {
            if (control.dataset.vedressSwatchBound === "true") return;
            const product = control.closest(".bls__product-item");
            if (!product) return;

            control.dataset.vedressSwatchBound = "true";
            let tooltipTimer;
            control.addEventListener("mouseout", () => {
              const swiper = control.closest(".swiper");
              if (!swiper) return;
              tooltipTimer = window.setTimeout(() => swiper.classList.remove("show-tooltip"), 400);
            });
            control.addEventListener("mouseover", () => {
              window.clearTimeout(tooltipTimer);
              window.BlsColorSwatchesShopify.listenerColor(control, product);
              control.closest(".swiper")?.classList.add("show-tooltip");
            });
          });
      }

      if (window.BlsSubActionProduct) {
        root.querySelectorAll(".bls__product-quickview").forEach((button) => {
          if (button.dataset.vedressQuickviewBound === "true") return;
          button.dataset.vedressQuickviewBound = "true";
          button.addEventListener("click", () => {
            button.classList.add("btn-loading");
            const product = button.closest(".bls__product-item");
            if (product?.dataset.productHandle) {
              window.BlsSubActionProduct.handleFetchDataQuickView(button, product.dataset.productHandle);
            }
          });
        });

        root.querySelectorAll(".bls__product-wishlist-js").forEach((button) => {
          if (button.dataset.vedressWishlistBound === "true") return;
          button.dataset.vedressWishlistBound = "true";
          button.addEventListener("click", window.BlsSubActionProduct.handleWishlistFunctionClick);
        });

        root.querySelectorAll(".bls__product-compare-js").forEach((button) => {
          if (button.dataset.vedressCompareBound === "true") return;
          button.dataset.vedressCompareBound = "true";
          button.addEventListener("click", window.BlsSubActionProduct.handleCompareFunctionClick);
        });

        window.BlsSubActionProduct.handleInitWishlist();
        window.BlsSubActionProduct.handleInitCompare();
      }

      window.BlsReloadSpr?.init();
    }

    initializeLazyImages(root) {
      /* [Modified by Codex at 2026-09-14] 动态商品复用全站唯一图片观察器 */
      if (window.BlsLazyloadImg?.init) {
        window.BlsLazyloadImg.init(root);
        return;
      }
      /* [End] */

      const images = root.querySelectorAll(".bls-image-js img:not([data-vedress-lazy-bound])");
      if (!("IntersectionObserver" in window)) {
        images.forEach((image) => image.classList.add("bls-loaded-image"));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, imageObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            image.width = entry.boundingClientRect.width;
            image.height = entry.boundingClientRect.height;
            image.sizes = `${entry.boundingClientRect.width}px`;
            image.classList.add("bls-loaded-image");
            image.closest(".bls-image-js")?.classList.remove("bls-loading-image");
            imageObserver.unobserve(image);
          });
        },
        { rootMargin: "100px" },
      );

      images.forEach((image) => {
        image.dataset.vedressLazyBound = "true";
        observer.observe(image);
      });
    }
  }

  const initialize = (scope = document) => {
    if (scope.matches?.(selector)) new VedressProductCarouselLazy(scope);
    scope.querySelectorAll?.(selector).forEach((carousel) => {
      new VedressProductCarouselLazy(carousel);
    });
  };

  window.VedressProductCarouselLazy = VedressProductCarouselLazy;
  initialize();
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
/* [End] */
